import { render, staticRenderFns } from "./MitVolumesAnalytics.vue?vue&type=template&id=86bbda54&scoped=true"
import script from "./MitVolumesAnalytics.vue?vue&type=script&lang=js"
export * from "./MitVolumesAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bbda54",
  null
  
)

export default component.exports